const urlImageKit = "https://ik.imagekit.io/makermarket/";
const urlImage = "https://maker-market-media.s3.us-east-1.amazonaws.com/";
const params = "?tr=w-218,h-150,c-at_least,fo-auto,q-30,f-webp";

export const cardProducts = [
  {
    image: urlImage + "designs/images/undefined/20250613173306675_s0vuyz",
    imageCompress:
      urlImageKit +
      "designs/images/undefined/20250613173306675_s0vuyz" +
      params,
    title: "Chaveiro Personalizado | Brinde Corporativo e Presente Exclusivo",
    id: "12287",
    price: "R$ 7,73",
    trendTop: true,
  },
  {
    image: urlImage + "designs/images/12313/SL-7.jpg",
    imageCompress: urlImageKit + "designs/images/12313/SL-7.jpg" + params,
    title:
      "Formiga Maker - Miniatura Oficial da maior formiga do mundo, exposta na 31ª Fenadoce 2025",
    id: "12313",
    price: "R$ 49,95",
  },
  {
    image: urlImage + "designs/images/12288/20250627153531320_hb4xco",
    imageCompress:
      urlImageKit + "designs/images/12288/20250627153531320_hb4xco" + params,
    title: "Base para Identificação de Mesa | Suporte de Sinalização e Números",
    id: "12288",
    price: "R$ 26,90",
  },
  {
    image: urlImage + "designs/images/12289/20250627161440646_uddyy3",
    imageCompress:
      urlImageKit + "designs/images/12289/20250627161440646_uddyy3" + params,
    title: "Maleta Personalizada – Presente Perfeito e Organização com Estilo",
    id: "12289",
    price: "R$ 107,75",
  },
  {
    image: urlImage + "designs/images/727/20250531142305724_ohdi7c.jpg",
    imageCompress:
      urlImageKit + "designs/images/727/20250531142305724_ohdi7c.jpg" + params,
    title: "Suporte Dock para iPhone 13 mini – Modo Espera Otimizado",
    id: "727",
    price: "R$ 53,60",
  },
  {
    image: urlImage + "designs/images/783/20250531142544054_i38q4g.jpg",
    imageCompress:
      urlImageKit + "designs/images/783/20250531142544054_i38q4g.jpg" + params,
    title: "Apito de Sinalização Potente 128dB",
    id: "783",
    price: "R$ 1,70",
  },
  {
    image: urlImage + "designs/images/790/20250531142545483_wcbfes.jpg",
    imageCompress:
      urlImageKit + "designs/images/790/20250531142545483_wcbfes.jpg",
    title: "Escultura Golfinho Zen",
    id: "790",
    price: "R$ 1,95",
  },
  {
    image: urlImage + "designs/images/900/20250531143436717_udrh0t.png",
    imageCompress:
      urlImageKit + "designs/images/900/20250531143436717_udrh0t.png" + params,
    title: "Engate Rápido Premium para Mangueira de Jardim 1/2",
    id: "900",
    price: "R$ 32,77",
  },
  {
    image: urlImage + "designs/images/925/20250531143957631_bd2z3q.jpg",
    imageCompress:
      urlImageKit + "designs/images/925/20250531143957631_bd2z3q.jpg" + params,
    title: "Raposa Geométrica Decorativa para Lar e Escritório",
    id: "925",
    price: "R$ 2,33",
  },
  {
    image: urlImage + "designs/images/937/20250531143958002_e4j7gn.jpeg",
    imageCompress:
      urlImageKit + "designs/images/937/20250531143958002_e4j7gn.jpeg" + params,
    title:
      "Vaso Porta-Canetas Rosto Divertido: Design Criativo para Escritório",
    id: "937",
    price: "R$ 36,30",
  },
  {
    image: urlImage + "designs/images/1152/20250531145350246_2acl0o.webp",
    imageCompress:
      urlImageKit +
      "designs/images/1152/20250531145350246_2acl0o.webp" +
      params,
    title:
      "Caveira Decorativa Sombria - Escultura e Organizador de Mesa Gótico",
    id: "1152",
    price: "R$ 47,73",
  },
  {
    image: urlImage + "designs/images/1264/20250531150501598_ad1svo.jpg",
    imageCompress:
      urlImageKit + "designs/images/1264/20250531150501598_ad1svo.jpg" + params,
    title: "Suporte Premium para Jogos PS5: Organização e Estilo para Gamers",
    id: "1264",
    price: "R$ 72,65",
  },
  {
    image: urlImage + "designs/images/1276/20250531150501808_hj6r5p.jpg",
    imageCompress:
      urlImageKit + "designs/images/1276/20250531150501808_hj6r5p.jpg" + params,
    title: "Troféu Personalizado de Reconhecimento",
    id: "1276",
    price: "R$ 45,75",
  },
  {
    image: urlImage + "designs/images/1286/20250531150502688_u4nszn.jpg",
    imageCompress:
      urlImageKit + "designs/images/1286/20250531150502688_u4nszn.jpg" + params,
    title: "Cápsula Corporação Z: Item Colecionável Goku & Bulma",
    id: "1286",
    price: "R$ 7,92",
  },
  {
    image: urlImage + "designs/images/1377/20250531151310693_0pcurw.jpg",
    imageCompress:
      urlImageKit + "designs/images/1377/20250531151310693_0pcurw.jpg" + params,
    title:
      "Porta-Cartões de Visita para Mesa e Balcão – Expositor Profissional",
    id: "1377",
    price: "R$ 61,78",
  },
  {
    image: urlImage + "designs/images/1443/20250531151730005_u44y86.webp",
    imageCompress:
      urlImageKit +
      "designs/images/1443/20250531151730005_u44y86.webp" +
      params,
    title: "Suporte Minimalista para Relógio – Expositor de Mesa",
    id: "1443",
    price: "R$ 4,63",
  },
];
